/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'Navigation',
        import: () => import('@stories/Widgets/Global/Navigation/Navigation'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Breadcrumbs',
        import: () => import('@stories/Widgets/Global/Breadcrumbs/Breadcrumbs'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'always',
        },
    },
    // Banners
    {
        name: 'HomepageHeroBanner',
        import: () => import('@stories/Widgets/HomepageHeroBanner/HomepageHeroBanner'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'InnerPageHero',
        import: () => import('@stories/Widgets/InnerPageHero/InnerPageHero'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'IntermediariesHomepageHeroBanner',
        import: () => import('@stories/Widgets/IntermediariesHomepageHeroBanner/IntermediariesHomepageHeroBanner'),
        config: {
            hydrate: 'always',
        },
    },
    // Widgets
    {
        name: 'AffordabilityCalculator',
        import: () => import('@stories/Widgets/AffordabilityCalculator/AffordabilityCalculator'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'BranchCards',
        import: () => import('@stories/Widgets/BranchCards/BranchCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'BuyToLetRentalIncomeCalculator',
        import: () => import('@stories/Widgets/BuyToLetRentalIncomeCalculator/BuyToLetRentalIncomeCalculator'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'BranchMap',
        import: () => import('@stories/Widgets/BranchMap/BranchMap'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContactCard',
        import: () => import('@stories/Widgets/ContactCard/ContactCard'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'DecisionInPrincipleForm',
        import: () => import('@stories/Widgets/DecisionInPrincipleForm/DecisionInPrincipleForm'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Documents',
        import: () => import('@stories/Widgets/Documents/Documents'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'DownloadTiptonAppCta',
        import: () => import('@stories/Widgets/DownloadTiptonAppCta/DownloadTiptonAppCta'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'EmbeddedForm',
        import: () => import('@stories/Widgets/EmbeddedForm/EmbeddedForm'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'EmbedIFrame',
        import: () => import('@stories/Widgets/EmbedIFrame/EmbedIFrame'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Faqs',
        import: () => import('@stories/Widgets/Faqs/Faqs'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FeaturedNews',
        import: () => import('@stories/Widgets/FeaturedNews/FeaturedNews'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FlowchartSteps',
        import: () => import('@stories/Widgets/FlowchartSteps/FlowchartSteps'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HowToGuide',
        import: () => import('@stories/Widgets/HowToGuide/HowToGuide'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ImageWidget',
        import: () => import('@stories/Widgets/Image/Image'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MediaGallery',
        import: () => import('@stories/Widgets/MediaGallery/MediaGallery'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MeetTheTeam',
        import: () => import('@stories/Widgets/MeetTheTeam/MeetTheTeam'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MortgageGlossary',
        import: () => import('@stories/Widgets/MortgageGlossary/MortgageGlossary'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MortgageProductFinder',
        import: () => import('@stories/Widgets/MortgageProductFinder/MortgageProductFinder'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'NewsArticleHeader',
        import: () => import('@stories/Widgets/NewsArticleHeader/NewsArticleHeader'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'NewsListing',
        import: () => import('@stories/Widgets/NewsListing/NewsListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PostcodeLookup',
        import: () => import('@stories/Widgets/PostcodeLookup/PostcodeLookup'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ProductDetails',
        import: () => import('@stories/Widgets/ProductDetails/ProductDetails'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ProductHero',
        import: () => import('@stories/Widgets/ProductHero/ProductHero'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ProductListingMortgages',
        import: () => import('@stories/Widgets/ProductListingMortgages/ProductListingMortgages'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ProductListingSavings',
        import: () => import('@stories/Widgets/ProductListingSavings/ProductListingSavings'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'QuickLinks',
        import: () => import('@stories/Widgets/QuickLinks/QuickLinks'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RelatedNews',
        import: () => import('@stories/Widgets/RelatedNews/RelatedNews'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RichText',
        import: () => import('@stories/Widgets/RichText/RichText'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SavingsInterestCalculator',
        import: () => import('@stories/Widgets/SavingsInterestCalculator/SavingsInterestCalculator'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SavingsProductFinder',
        import: () => import('@stories/Widgets/SavingsProductFinder/SavingsProductFinder'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Signposts',
        import: () => import('@stories/Widgets/Signposts/Signposts'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SplitContentCard',
        import: () => import('@stories/Widgets/SplitContentCard/SplitContentCard'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SearchResults',
        import: () => import('@stories/Widgets/SearchResults/SearchResults'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TabbedSignposts',
        import: () => import('@stories/Widgets/TabbedSignposts/TabbedSignposts'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Testimonials',
        import: () => import('@stories/Widgets/Testimonials/Testimonials'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Usps',
        import: () => import('@stories/Widgets/Usps/Usps'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'VacancyListing',
        import: () => import('@stories/Widgets/VacancyListing/VacancyListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'WarningMessage',
        import: () => import('@stories/Widgets/WarningMessage/WarningMessage'),
        config: {
            hydrate: 'in-view',
        },
    },
];
